<template>
	<div class='position-relative d-flex flex-column flex-grow-1-scroll h-100' ref="container">
        <loading ref="loading"></loading>
		<compact-message-list v-on:back='thread_id = null' :thread_id='thread_id' :archive='thread.archived' v-if='thread_id != null'></compact-message-list>
		<template v-else>
			<header class="list-header" style="z-index: 100;">
			</header>

			<list-filter :key='event' ref="listFilter" :modalid='modalid'></list-filter>

			<div class="errors">
	            <template v-for="(error, key) in errors">
	                <p class="alert alert-warning" v-for="message in error">{{message}}</p>
	            </template>
	        </div>
			<div class='flex-grow-1-scroll'>
				<div class="p-2" v-show='items.data instanceof Array && items.data.length === 0'>{{ $t('translations.no_items_found')}}</div>
				<ul class="list list-thread">

					<!-- <router-link tag='li' :to='(subroute ? "/" + event + "-list" : "") + "/" + event + "-show/" + item.id' v-for="item in items.data" :key='item.id' :class="list-thread_item"'> -->
					<li v-on:click.prevent='thread_id = item.id; thread = item' v-for="item in items.data" :key='item.id' :class='"list-thread_item"'>
						<div class='list-flags'>
                            <span v-if='is_archived(item)' :title="$t('translations.archived')" v-html="$t('translations.archived')" class="icon icon-archived"></span>
							<span v-else-if='is_closed(item)' title='closed' v-html='"Closed"' class="icon icon-closed"></span>
							<template v-else>
								<span v-if='is_unassigned(item)' title='New' class="icon icon-unassigned"></span>
                                <span v-if='is_assignedToMe(item)' :title='assignee_name(item)' v-html='"Mine"' class="icon icon-mine"> </span>
                                <span v-else-if='is_assignedToMyGroups(item)' :title='assignee_name(item)' v-html="$t('translations.mine')" class="icon icon-my-group"> </span>
								<span v-else-if='is_assigned(item)' :title='assignee_name(item)' v-html='"Assigned"' class="icon icon-assigned"> </span>

								
                                <span v-if='new_message(item)' title='Unread messages' class="icon icon-unread"></span>
								
							</template>
						</div>
						<div class="d-flex flex-wrap thread-meta">
							<span class="time-stamp">{{item.created_at| formatDateTime}}</span>
						</div>
						<p>{{(item.question_group && item.question_group.question_group_type_id == 1) ? $t('translations.qa_in_progress') : ""}} {{item.subject ? item.subject : "[" + $t('translations.no_subject') + "]"}}</p>
					</li>
					<!-- </router-link> -->


				</ul>
                <div class="text-center">
                <button v-if='environment_settings.MIX_ENABLE_ARCHIVE && !archive && items.next_page_url == null' type='button' class='btn btn-primary' v-on:click='enableArchive()'>
                    {{ autobrand('translations.continue_search_in_archive') }}
                </button>
            </div>
			</div>
			<footer class='list-footer open'>
				<paginator  :pagination="items"
	                 @paginate="getResults()"
					 :offset="1"
                     :simple='true'></paginator>
			</footer>
		</template>
	</div>
</template>

<script>
 /**
  * @vue-prop {String} route - The route to use for API calls
  * @vue-prop {String} event - The event name
  * @vue-prop {String} model - The model name
  * @vue-prop {String} path - The router path
  * @vue-prop {String} title - The title of the listing
  * @vue-prop {String} title - The vue component that we will use to display the items.
  * @vue-prop {String} modalid - The ID used for the internal modal used for filters.
  * @vue-prop {Boolean} subroute=1 - Whether the router is a subroute
  * @vue-data {Object|Array} items - The items to list
  * @vue-data {Object|Array} filterFields - The filter fields available
  * @vue-data {Number} page - The current page
  * @vue-data {Object|Array} errors - An array of errors to display
  * @vue-data {Object|Array} quickFilters - The quick filters available
  * @vue-computed {Boolean} connected Whether we are connected to the server.
  */
	export default {
		props: {
			'route': {},
			'event': {},
			'model': {},
			// @todo Review this as we can just use this.$router.path
			'path': {},
			'title': {},
			'displayelement': {},
			'modalid': {},
			'subroute': {
				default: 1
			},
			exclude_thread_id: {
				default: 0
			},
			user: {
			},
		},
		data: function(){
			return {
				items: {},
				filterFields: {},
				page: 1,
				errors: [],
				notification: "",
				test_state: true,
				quickFilters: {
					//assigned: false
				},
				messageListShown: false,
                thread_id: null,
                thread: null,
                archive: false,
			};
		},
		computed: {
			connected() {
				return this.$root.connected;
			},
			// thread() {
			// 	return this.$parent.thread;
			// },
			// exclude_thread_id() {
			// 	if(this.$parent.thread) {
			// 		return this.$parent.thread.id;
			// 	}
			// 	return 0;
			// },
			// user_id() {
			// 	if(this.$parent.thread) {
			// 		return this.$parent.thread.user_id;
			// 	}
			// 	// Need to fix this $parent reference and instead pass the user_id to
			// 	// the generic interfaces.
			// 	else if(this.$parent.item && this.$parent.item.id) {
			// 		return this.$parent.item.id;
			// 	}
			// 	else return false;
			// }
		},
		watch: {
			route: function (val) {
		 		this.initData();
		    },
    		connected (newState, oldState) {
				this.getResults();
		    },
			// thread () {
			// 	this.getResults();
			// },
			user () {
				this.getResults();
			},
			exclude_thread_id () {
				this.getResults();
			}
		},
		created() {
        },
		beforeDestroy() {
		},
		mounted() {
			console.log("mounted");
			if(this.user) {
				this.initData();
			}

		},

		methods: {
			/**
			 * Toggle quick filters
			 * @param  {String} filter The filter to toggle
			 */
			toggleFilter(filter) {
				this.$router.push({path: "/" + this.event + "-list"});
				this.quickFilters[filter] = !this.quickFilters[filter];
				this.getResults();
			},
			// @updatehere
			initData() {
				this.setLoading(true);
				this.items = {};
				this.errors = [];

				this.$set(this.quickFilters, 'assigned', true);
				this.$set(this.quickFilters, 'unassigned', true);
				this.$set(this.quickFilters, 'mine', true);
				this.$set(this.quickFilters, 'closed', true);
				//this.quickFilters["assigned"] = false;


				this.initFilters();
				this.getResults(1);
            },
            // @updatehere
			initFilters() {
                if(this.$root.lookup.filters[this.route]) {
                    Vue.nextTick(() => {
                        this.$refs.listFilter.filterFields = this.$root.lookup.filters[this.route];
                        this.$refs.listFilter.clearFilters(null);
                    });
                }
                else {
                    this.setLoading(true);
                    axios.get(this.route + '/getFilters').then((res) => {
                        this.$root.lookup.filters[this.route] = res.data;
                        this.$refs.listFilter.filterFields = res.data;
                        //this.$refs.listFilter.clearFilters(null);
                    });
                }
			},
			// @updatehere
			initFiltersOld() {
				this.setLoading(true);
				axios.get(this.route + '/getFilters').then((res) => {
					this.$refs.listFilter.filterFields = res.data;
					//this.$refs.listFilter.clearFilters(null);
				});
			},
			// @updatehere
			getResults(page, event, prevent) {
				//this.setLoading(true);
				if(this.user && this.user.id) {
					if (typeof page !== 'undefined') {
						this.items.current_page = page;
					}

					var search = (this.$refs && this.$refs.listFilter ? this.$refs.listFilter.$refs.search.value : "");

					// Bit of a hack this. We want all the filters turned on for this list.
					this.quickFilters['assigned'] = true;
					this.quickFilters['unassigned'] = true;
					this.quickFilters['mine'] = true;
					this.quickFilters['closed'] = true;


					var filter = encodeURIComponent(JSON.stringify(this.quickFilters));

					if(this.$refs && this.$refs.listFilter && this.$refs.listFilter.filterShown) {
						search = encodeURIComponent(JSON.stringify(this.$refs.listFilter.appliedFilters));
					}
					search=encodeURIComponent(JSON.stringify([{field: "id", type: "!=", value: this.exclude_thread_id}, {field: "user_id", type: "=", value: this.user.id}]));
					axios.get(this.route + '?search=' + search + '&filter=' + filter + '&page=' + this.items.current_page + (this.archive ? '&archive=1' : '')).then((res) => {
						if(res.data.current_page > res.data.last_page && prevent !== true) {
							console.log("Re-searching with page in range.");
							this.items = {};
							this.getResults(res.data.last_page, undefined, true)
						}
						else {
							this.setLoading(false);
                            this.items = res.data;
                            this.$emit("loaded");
						}
					});
				}

			},
			showFilter() {
				$(this.$refs.listFilter.$refs.modal).modal("show");
				setTimeout(function() {
					if (this.$refs.listFilter.filterShown) {
    					$(this.$refs.listFilter.$refs["filter-value-0"]).focus();
    				}
    				else {
    					$(this.$refs.listFilter.$refs.search).focus();
    				}
		        }.bind(this), 500);

			},
			is_assigned(item) {
				if(item.thread_provider && (item.thread_provider.assigned_user_id || item.thread_provider.assigned_group_id)) {
					return true
				}
				return false;
			},
			is_unassigned(item) {
				if(item.thread_provider && (!item.thread_provider.assigned_user_id && !item.thread_provider.assigned_group_id)) {
					return true
				}
				return false;
			},
			is_assignedToMe(item) {
				if(item.thread_provider && item.thread_provider.assigned_user_id == this.$root.user.id) {
					return true
				}

				return false;
            },
            is_assignedToMyGroups(item) {
				if(item.thread_provider && item.thread_provider.assigned_group_id) {
					//alert("item.thread_provider.assigned_group_id:" + item.thread_provider.assigned_group_id);
					var val = this.$root.user.user_group.filter(obj => {
						//alert("obj.user_group_id: " + obj.user_group_id);
						//console.log("Comparing: " + "item.thread_provider.assigned_group_id:" + item.thread_provider.assigned_group_id + " to " + "obj.user_group_id: " + obj.user_group_id);
						return item.thread_provider.assigned_group_id == obj.user_group_id;
					});
					return val.length;
				}
				return false;
			},
			new_message(item) {
				if(this.is_assignedToMe(item) || this.is_unassigned(item)) {
					if(!item.user_thread_read_status) {
						return true;
					}
					if(item.latest_message != null && typeof item.latest_message == "object" && item.latest_message.created_at > item.user_thread_read_status.read_at) {
						return true;
					}
				}
				return false;
			},

			is_closed(item) {
				if(item.closed_at) {
					return true
				}
				return false;
            },
            is_archived(item) {
				if(item.archived) {
					return true
				}
				return false;
			},

			assignee_name(item) {
				if(item.thread_provider && item.thread_provider.assigned_user_id) {
					return item.thread_provider.assigned_user.surname + ", " + item.thread_provider.assigned_user.forenames;
				}
				else if(item.thread_provider && item.thread_provider.assigned_group_id) {
					return item.thread_provider.assigned_group.name;
				}
				return "Unassigned";

			},
			showPanel1() {
				this.messageListShown = true;
            },
            enableArchive() {
                //console.info(this.user);
                this.$root.checkArchive(this.user, () => {
                    this.archive = true;
                    this.getResults();
                });
                
                
            }
		}
    }
</script>
